import { render, staticRenderFns } from "./ModalSelecionarTerritoriosBaseVegaSobrepostosAR.vue?vue&type=template&id=6ff2faf4&scoped=true&lang=pug"
import script from "./ModalSelecionarTerritoriosBaseVegaSobrepostosAR.vue?vue&type=script&lang=js"
export * from "./ModalSelecionarTerritoriosBaseVegaSobrepostosAR.vue?vue&type=script&lang=js"
import style0 from "./ModalSelecionarTerritoriosBaseVegaSobrepostosAR.vue?vue&type=style&index=0&id=6ff2faf4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff2faf4",
  null
  
)

export default component.exports